<script lang="ts" setup>
import { Policy } from '@/interfaces/policy';


interface props {
    policy?: Policy
}

const props = defineProps<props>();




</script>

<template>
    <div>
        <ul class="grid grid-cols-2 gap-x-2">

            <li v-for="option in props.policy?.rule[0].options" :key="option">
                <p class="text-sm">{{ option }}</p>
            </li>
        </ul>
    </div>
</template>
  
  

  